<template>
  <div class="popup z-index-10-fg confirmation small-popup delay-alert-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Don't Alert Until...</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div class="popup-body">
        <div class="primary-input">
          <input type="date" v-model="date" />
          <label>Date</label>
        </div>
      </div>
      <div class="popup-footer">
        <button @click="$emit('closePopup')" class="text-btn">close</button>
        <button :disabled="isSaving" :class="{ 'square-btn': true, saving: isSaving }" @click="updateDelayAlert()">Save<img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import useLeadsQuery from '@/composables/useLeadsQuery';
import useLeadMutate from '@/composables/useLeadMutate';
import useCurrentUser from '@/composables/useCurrentUser';
import useAlerts from '@/composables/useAlerts';

export default {
  name: 'DelayAlert',
  emits: ['closePopup'],
  props: {
    leadid: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { updateLead } = useLeadMutate();
    const { user } = useCurrentUser();
    const { addAlert } = useAlerts();

    return {
      leads: useLeadsQuery.leadsIncludingSingleLead,
      user,
      addAlert,
      updateLead,
    };
  },
  data() {
    return {
      date: '',
      isSaving: false,
    };
  },
  methods: {
    async updateDelayAlert() {
      this.isSaving = true;
      const lead = this.leads.find((lead) => lead.LEADID === this.leadid);
      if (!lead) {
        this.addAlert('Error saving delay alert', 'high', 4);
        this.$emit('closePopup');
        return;
      }

      if (this.date) {
        lead.ALERTDELAY = (new Date(this.date).getTime() + 8 * 60 * 60 * 1000).toString();
      } else {
        lead.ALERTDELAY = null;
      }
      const updatedLead = { ALERTDELAY: this.date || null };

      await this.updateLead(lead.LEADID, updatedLead);

      this.isSaving = false;
      this.addAlert('Delay alert updated', 'low', 3);

      this.$emit('closePopup');
    },
    getISODate(date) {
      return date ? `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}` : null;
    },
  },
  mounted() {
    const lead = this.leads.find((lead) => lead.LEADID === this.leadid);
    if (lead) {
      this.date = lead.ALERTDELAY ? this.getISODate(new Date(parseInt(lead.ALERTDELAY))) : null;
    }
  },
};
</script>

<style lang="scss" scoped>
.delay-alert-popup {
  width: 30rem;

  .popup-body {
    .title {
      font-size: $fontSize16;
      margin: 0;
      display: flex;
      align-items: center;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
      img {
        margin-left: 0.5rem;
      }
    }

    .text {
      font-size: $fontSize13;
      margin: 1rem 0;
    }
  }
}
</style>
